import React, { createContext } from 'react';

import type { AuthenticatedUser, AllowedCourseItem } from '../types';

export interface AppDataContextType {}

interface AppContextType {
  allowedCourses: AllowedCourseItem[];
  allowedCoursesLoaded: boolean;
  appData: AppDataContextType;
  authenticatedUser: AuthenticatedUser | null;
  setAppData: React.Dispatch<React.SetStateAction<AppDataContextType>>;
  setAuthenticatedUser: React.Dispatch<React.SetStateAction<AuthenticatedUser | null>>;
}

export const AppDataContext = createContext<AppContextType>({
  allowedCourses: [],
  allowedCoursesLoaded: false,
  appData: {} as AppDataContextType,
  authenticatedUser: null,
  setAppData: () => {},
  setAuthenticatedUser: () => {},
});
